import { FaFacebookF, FaInstagram, FaYoutube, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#1A1F2B] text-[#F5E9D8] pt-16 pb-8 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">

        {/* ===== CHURCH INFO ===== */}
        <div aos-data="fade-up">
          <h2 className="text-2xl font-semibold text-[#D9A05B] mb-4">
            Moriah Church – प्रार्थना भवन
          </h2>
          <p className="leading-relaxed">
            A Christ-centered community in Naraina, New Delhi, devoted to worship,
            prayer, and spiritual growth. Our mission is to bring hope, healing,
            and the message of Jesus Christ to every family.
          </p>
        </div>

        {/* ===== QUICK LINKS ===== */}
        <div aos-data="fade-up">
          <h3 className="text-xl font-semibold text-[#D9A05B] mb-4">
            Quick Links
          </h3>
          <ul className="space-y-3">
            <li><a href="/" className="hover:text-[#D9A05B] transition">Home</a></li>
            <li><a href="/about" className="hover:text-[#D9A05B] transition">About</a></li>
            <li><a href="/services" className="hover:text-[#D9A05B] transition">Services</a></li>
            <li><a href="/testimony" className="hover:text-[#D9A05B] transition">Testimony</a></li>
            <li><a href="/photos" className="hover:text-[#D9A05B] transition">Photos</a></li>
          </ul>
        </div>

        {/* ===== CONTACT ===== */}
        <div>
          <h3 className="text-xl font-semibold text-[#D9A05B] mb-4" aos-data="fade-up">
            Contact Us
          </h3>

          <p className="mb-3 flex items-center gap-2">
            <FaMapMarkerAlt className="text-[#D9A05B]" /> Naraina, New Delhi – India
          </p>

          <p className="mb-3 flex items-center gap-2">
            <FaPhoneAlt className="text-[#D9A05B]" />
            <a href="tel:8800229968" className="hover:text-[#D9A05B] transition">
              8800229968
            </a>
          </p>

          <p className="mb-4">
            ✉️ <a
              href="mailto:moriahchurchnaraina@gmail.com"
              className="hover:text-[#D9A05B] transition"
            >
              moriahchurchnaraina@gmail.com
            </a>
          </p>

          {/* ===== SOCIAL MEDIA ===== */}
          <div className="flex items-center gap-4 mt-6" aos-data="fade-up">
            <a
              href="https://www.facebook.com/moriahchurchdelhi"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-[#D9A05B] text-[#1A1F2B] hover:bg-[#C9A86A] transition"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/moriahchurch.naraina/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-[#D9A05B] text-[#1A1F2B] hover:bg-[#C9A86A] transition"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.youtube.com/@moriahchurch7039"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-[#D9A05B] text-[#1A1F2B] hover:bg-[#C9A86A] transition"
            >
              <FaYoutube />
            </a>
          </div>

          <a
            href="https://us02web.zoom.us/j/5015391726"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-6 px-6 py-3 rounded-full bg-[#D9A05B] text-[#1A1F2B] font-semibold hover:bg-[#C9A86A] transition duration-300 shadow-md"
          >
            Join Worship Online
          </a>
        </div>
      </div>

      {/* ===== COPYRIGHT ===== */}
      <div className="mt-12 border-t border-[#D2CBC3]/20 pt-6 text-center text-sm text-[#D2CBC3]">
        © {new Date().getFullYear()} Moriah Church – प्रार्थना भवन. All Rights Reserved.
      </div>
    </footer>
  );
}
